import { render, staticRenderFns } from "./IconSvgACPAMyprofile.vue?vue&type=template&id=87133a30&scoped=true&"
import script from "./IconSvgACPAMyprofile.vue?vue&type=script&lang=js&"
export * from "./IconSvgACPAMyprofile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87133a30",
  null
  
)

export default component.exports